import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AdminHiddenStories } from '../components/admin/AdminHiddenStories';
import { AdminManualStoryBuilder } from '../components/admin/AdminManualStoryBuilder';
import { ShieldAlert } from 'lucide-react';

const AdminPage = () => {
  const { isLoggedIn, isAdmin, loading } = useAuth();

  if (loading) return null;

  if (!isLoggedIn || !isAdmin) {
    return (
      <div className="max-w-lg mx-auto px-4 py-16 text-center" data-testid="admin-access-denied">
        <ShieldAlert className="w-10 h-10 text-gray-400 mx-auto mb-3" />
        <h1 className="text-lg font-semibold text-gray-900 mb-1">Admin access required</h1>
        <p className="text-sm text-gray-500 mb-4">Sign in with the admin account to manage the feed.</p>
        <Link to="/profile" className="text-blue-600 text-sm font-medium hover:underline" data-testid="admin-go-to-profile-link">
          Go to Profile to sign in
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 space-y-10" data-testid="admin-page">
      <div>
        <h1 className="text-2xl font-serif font-bold text-gray-900">Admin panel</h1>
        <p className="text-sm text-gray-500 mt-1">Curate what shows up on the homepage feed.</p>
      </div>

      <section>
        <h2 className="text-base font-semibold text-gray-900 mb-1">Stories not on the homepage</h2>
        <p className="text-xs text-gray-500 mb-4">
          Stories older than the feed's pagination window. Feature one to inject it into today's feed.
        </p>
        <AdminHiddenStories />
      </section>

      <section>
        <h2 className="text-base font-semibold text-gray-900 mb-1">Create a manual spectrum</h2>
        <p className="text-xs text-gray-500 mb-4">
          Paste article links, order them left-to-right by stance, and publish a new story to today's feed.
        </p>
        <AdminManualStoryBuilder />
      </section>
    </div>
  );
};

export default AdminPage;
